import React from "react"
import { batch } from "@preact/signals-react"

import { AppAntSwitch } from "@components"
import { includeProviders, mainSiteProvider, mainSite, mainProvider } from "@signals"


export default function WebProviderToggleButton({ ...props }) {
	return <>
		<AppAntSwitch
			falseText="Web"
			trueText="Web & Provider"
			checked={includeProviders.value}
			onChange={newValue => {
				includeProviders.value = newValue.target.checked
				mainSiteProvider.value = false
			}}
			{...props}
		/>
		{ includeProviders.value && <AppAntSwitch
			trueText="Main provider"
			falseText="Main site"
			checked={mainSiteProvider.value}
			onChange={newValue => batch(() => {
				mainSiteProvider.value = newValue.target.checked
				mainSite.value = ''
				mainProvider.value = ''
			})}
			{...props}
		/> }
	</>
}